const LogoMarquee = ({ 
  logos = [], 
  speed = "slow", 
  direction = "left",
  className = "",
  pauseOnHover = true 
}) => {
  // Default logos if none provided
  const defaultLogos = [
    { name: "Partner 1", url: "#" },
    { name: "Partner 2", url: "#" },
    { name: "Partner 3", url: "#" },
    { name: "Partner 4", url: "#" },
    { name: "Partner 5", url: "#" },
    { name: "Partner 6", url: "#" },
  ];

  const logoItems = logos.length > 0 ? logos : defaultLogos;

  const speedClasses = {
    slow: "animate-marquee-slow",
    medium: "animate-marquee-medium", 
    fast: "animate-marquee-fast"
  };

  const directionClass = direction === "right" ? "reverse" : "";

  return (
    <div className={`relative overflow-hidden bg-gradient-to-r from-white via-gray-50 to-white py-8 ${className}`}>
      {/* Gradient masks */}
      <div className="absolute left-0 top-0 z-10 h-full w-20 bg-gradient-to-r from-white to-transparent" />
      <div className="absolute right-0 top-0 z-10 h-full w-20 bg-gradient-to-l from-white to-transparent" />
      
      {/* Marquee container */}
      <div 
        className={`flex w-max ${speedClasses[speed]} ${directionClass} ${pauseOnHover ? 'hover:pause' : ''}`}
        style={{ animationDirection: direction === "right" ? "reverse" : "normal" }}
      >
        {/* First set of logos */}
        <div className="flex items-center justify-center gap-12 px-6">
          {logoItems.map((logo, index) => (
            <LogoItem key={`first-${index}`} logo={logo} />
          ))}
        </div>
        
        {/* Duplicate set for seamless loop */}
        <div className="flex items-center justify-center gap-12 px-6">
          {logoItems.map((logo, index) => (
            <LogoItem key={`second-${index}`} logo={logo} />
          ))}
        </div>
      </div>
    </div>
  );
};

const LogoItem = ({ logo }) => {
  const content = (
    <div className="flex items-center justify-center h-16 w-32 rounded-lg border bg-white/80 backdrop-blur-sm shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105 group">
      {logo.image ? (
        <img 
          src={logo.image} 
          alt={logo.name}
          className="max-h-12 max-w-28 object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
        />
      ) : (
        <span className="text-sm font-medium text-gray-500 group-hover:text-deep-green transition-colors duration-300">
          {logo.name}
        </span>
      )}
    </div>
  );

  if (logo.url && logo.url !== "#") {
    return (
      <a 
        href={logo.url} 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex-shrink-0"
      >
        {content}
      </a>
    );
  }

  return <div className="flex-shrink-0">{content}</div>;
};

export default LogoMarquee;
